function opacityValue(value, fallback = 1) {
  const numeric = Number(value);
  return Number.isFinite(numeric) ? Math.max(0, Math.min(1, numeric)) : fallback;
}

/**
 * Applies contextual focus to the existing public-map DOM without replacing
 * React Flow's node or edge arrays. This keeps the transformed canvas stable
 * during rapid pointer movement on dense maps.
 */
export function applyPublicHoverPresentation(container, graph) {
  if (!container || !graph) return;

  const nodes = new Map(
    (graph.nodes || []).map((node) => [String(node.id), opacityValue(node.style?.opacity)])
  );
  const edges = new Map(
    (graph.edges || []).map((edge) => [String(edge.id), {
      opacity: opacityValue(edge.style?.opacity),
      labelOpacity: opacityValue(edge.data?.relationshipLabelStyle?.opacity),
      showLabel: edge.data?.showRelationshipLabel !== false,
    }])
  );

  container.querySelectorAll("[data-knowledge-node-id]").forEach((surface) => {
    const opacity = nodes.get(surface.dataset.knowledgeNodeId);
    if (opacity !== undefined) surface.style.opacity = String(opacity);
  });

  container.querySelectorAll("[data-knowledge-edge-path]").forEach((path) => {
    const presentation = edges.get(path.dataset.knowledgeEdgePath);
    if (presentation) path.style.opacity = String(presentation.opacity);
  });

  container.querySelectorAll("[data-knowledge-edge-label]").forEach((label) => {
    const presentation = edges.get(label.dataset.knowledgeEdgeLabel);
    if (presentation) {
      label.style.opacity = presentation.showLabel ? String(presentation.opacity * presentation.labelOpacity) : "0";
    }
  });

  container.querySelectorAll("[data-knowledge-edge-mask-label]").forEach((maskLabel) => {
    const presentation = edges.get(maskLabel.dataset.knowledgeEdgeMaskLabel);
    if (!presentation) return;
    const color = presentation.showLabel ? "black" : "white";
    maskLabel.setAttribute("fill", color);
    maskLabel.setAttribute("stroke", color);
  });
}
